import { SourceTypeResponse } from "api/company";
import { ConfigResponse } from "api/shared";
import { SourceType } from "model";

export const isOptional = (
  sourceType: SourceType,
  config: ConfigResponse
): boolean => {
  switch (sourceType) {
    case "Accounting":
      return config.optionalSourceTypes.accounting;
    case "Banking":
      return config.optionalSourceTypes.banking;
    case "Commerce":
      return config.optionalSourceTypes.commerce;
    case "Other":
      return config.optionalSourceTypes.businessDocuments;
  }
};

export const canSkip = (
  currentSourceType: SourceTypeResponse | undefined,
  config: ConfigResponse
): boolean => {
  if (currentSourceType) {
    if (
      isOptional(currentSourceType.sourceType, config) ||
      currentSourceType.connected > 0
    ) {
      return true;
    }
  }

  return false;
};
